import React, { useState, useRef, useEffect } from "react";
import { FaBell, FaUser } from "react-icons/fa";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import authModule from "../../Modules/auth/auth-module";

const Header = ({ user, notifications }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown on profile click
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      {/* Left Section: Logo & App Name */}
      <div className="header-left">
        <img
          src={require("../../Assets/logo/assam-gov-logo-blue.png")}
          alt="Assam Govt Logo"
          className="logo"
        />
        <div>
          <div className="app-name">District Nirikshan</div>
          <div className="screen-name">Admin Panel - {user.district.name}</div>
        </div>
      </div>

      {/* Right Section: Notifications & Profile */}
      <div className="header-right">
        {/* Notifications */}
        <div className="notification-container">
          <FaBell className="notification-icon" />
          {notifications?.length > 0 && (
            <span className="notification-badge">{notifications.length}</span>
          )}
        </div>

        {/* Profile Dropdown */}
        <div className="profile" ref={dropdownRef} onClick={toggleDropdown}>
          {user.image?.url ? (
            <img
              src={user.image.url}
              alt="User Profile"
              className="profile-photo"
            />
          ) : (
            <FaUser className="profile-photo" />
          )}
          <span className="user-name">{user.name}</span>

          {/* Dropdown Menu */}
          {dropdownOpen && (
            <div className="profile-dropdown">
              <div className="profile-info">
                <strong>{user.name}</strong>
                <p>{user.office?.name}</p>
              </div>
              <Link to="" >👤 My Profile</Link>
              <a onClick={()=>authModule.logout()}>🚪 Logout</a>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  user: state.pState.AUTH?.user,
  notifications: state.vState.APP.notifications,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
